import { Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import check from '_assets/register/check.svg';
import checked from '_assets/register/checked.svg';

export default function StepComponent({ step, stepNb }) {
  const { palette } = useTheme();

  if (step === 1) return <></>
  if (step > 1 ) return <Typography>Unknown step</Typography>

  return (
    <>
      <Typography
        style={{
          textDecorationLine: stepNb > 0 ? 'line-through' : '',
          color: stepNb > 0 ? 'inherit' : palette.text.title,
        }}
        key='1'
      >
        <img
          alt='checkmark étape identifiants'
          src={stepNb > 0 ? checked : check}
          style={{ width: '16px', margin: '0 8px 0 8px' }}
        />
        Vos identifiants
      </Typography>

      <Typography
        style={{
          textDecorationLine: stepNb > 1 ? 'line-through' : '',
          color: stepNb > 1 ? 'inherit' : palette.text.title,
        }}
        key='2'
      >
        <img
          alt='checkmark étape identité'
          src={stepNb > 1 ? checked : check}
          style={{ width: '16px', margin: '0 8px 0 8px' }}
        />
        Votre identité
      </Typography>

      <Typography
        style={{
          textDecorationLine: stepNb > 2 ? 'line-through' : '',
          color: stepNb > 2 ? 'inherit' : palette.text.title,
        }}
        key='3'
      >
        <img
          alt='checkmark étape votre entreprise'
          src={stepNb > 2 ? checked : check}
          style={{ width: '16px', margin: '0 8px 0 8px' }}
        />
        Votre entreprise
      </Typography>
    </>
  );
}
